const apiEnum = {
  apiStatus: {
    fail: 0,
    success: 1,
    error: 2
  },
  permissionType: {
    api: 0,
    page: 1
  },
  orderStatus: {
    send: 0,
    loop: 10,
    assign: 15,
    receive: 20,
    contact: 30,
    sign: 40,
    finish: 50,
    cancel: 60
  },
  balanceType: {
    recharge: 1,
    deduct: 2
  },
  payType: {
    customer: 1,
    seller: 2
  },
  role: {
    admin: 1,
    seller: 2,
    store: 3,
    worker: 4,
    user: 5
  }
}

const formatterList = [
  {
    type: 'payType',
    field: 'pay_type',
    render: [
      {
        key: 1,
        value: '客户付款'
      },
      {
        key: 2,
        value: '商家付款'
      }
    ]
  },
  {
    type: 'orderState',
    field: 'status',
    render: [
      {
        key: '0',
        value: '未派单'
      },
      {
        key: '5',
        value: '已锁定'
      },
      {
        key: '10',
        value: '轮单中'
      },
      {
        key: '15',
        value: '派单中'
      },
      {
        key: '20',
        value: '已接单'
      },
      {
        key: '30',
        value: '已联系'
      },
      {
        key: '40',
        value: '上门签到'
      },
      {
        key: '50',
        value: '已完成'
      },
      {
        key: '60',
        value: '已取消'
      }
    ]
  },
  {
    type: 'oldOrderState',
    field: 'state',
    render: [
      {
        key: 'creat',
        value: '已下单'
      },
      {
        key: 'msg',
        value: '发信息'
      },
      {
        key: 'finish',
        value: '已安装'
      },
      {
        key: 'done',
        value: '结单'
      },
      {
        key: 'close',
        value: '已取消'
      }
    ]
  },
  {
    type: 'noticeType',
    field: 'type',
    render: [
      {
        key: 'price',
        value: '给商家价格'
      },
      {
        key: 'price_worker',
        value: '给师傅价格'
      },
      {
        key: 'serv_min_price',
        value: '服务最低价格'
      },
      {
        key: 'notice_send',
        value: '下单提醒'
      },
      {
        key: 'notice_assign',
        value: '接单前提醒'
      },
      {
        key: 'notice_receive',
        value: '接单状态提醒'
      },
      {
        key: 'notice_contact',
        value: '联系状态提醒'
      },
      {
        key: 'notice_sign',
        value: '签到状态提醒'
      },
      {
        key: 'notice_finish',
        value: '完成状态提醒'
      },
      {
        key: 'notice_cancel',
        value: '取消状态提醒'
      }
    ]
  },
  {
    type: 'balanceType',
    field: 'type',
    render: [
      {
        key: 1,
        value: '充值'
      },
      {
        key: 2,
        value: '扣钱'
      },
      {
        key: 3,
        value: '下单消费'
      },
      {
        key: 4,
        value: '淘宝下单充值'
      },
      {
        key: 5,
        value: '淘宝下单消费'
      },
      {
        key: 6,
        value: '师傅订单结款'
      },
      {
        key: 7,
        value: '取消订单退钱给商家'
      },
      {
        key: 8,
        value: '订单加价扣商家钱'
      },
      {
        key: 9,
        value: '客户付款师傅完成订单，补差价'
      },
      {
        key: 10,
        value: '提现'
      }
    ]
  }
]

const apiPath = '/api/';
const api = {
  // system
  account: {
    login: apiPath + 'account/login/1',
    verify: apiPath + 'account/verify/1',
    storeLogin: apiPath + 'account/login/3',
    storeVerify: apiPath + 'account/verify/3',
    logout: apiPath + 'account/logout',
    updatePwd: apiPath + 'account/update_pwd',
    getUserData: apiPath + 'account/get_userdata'
  },
  config: {
    edit: apiPath + 'config/edit/',
    getAll: apiPath + 'config/get_all/'
  },
  role: {
    add: apiPath + 'role/add/',
    del: apiPath + 'role/del/',
    edit: apiPath + 'role/edit/',
    get: apiPath + 'role/get/',
    getAll: apiPath + 'role/get_list/'
  },
  admin: {
    add: apiPath + 'admin/add/',
    del: apiPath + 'admin/del/',
    edit: apiPath + 'admin/edit/',
    get: apiPath + 'admin/get/',
    getAll: apiPath + 'admin/get_list/'
  },
  // role
  seller: {
    add: apiPath + 'seller/add/',
    del: apiPath + 'seller/del/',
    edit: apiPath + 'seller/edit/',
    get: apiPath + 'seller/get/',
    getList: apiPath + 'seller/get_list/',
    query: apiPath + 'seller/query/',
    getServList: apiPath + 'seller/get_serv_list'
  },
  sellerServ: {
    add: apiPath + 'seller_serv/add/',
    del: apiPath + 'seller_serv/del/',
    edit: apiPath + 'seller_serv/edit/',
    getList: apiPath + 'seller_serv/get_list/'
  },
  dealLog: {
    add: apiPath + 'deal_log/add/',
    worker: apiPath + 'deal_log/worker/',
    seller: apiPath + 'deal_log/seller/',
    getAll: apiPath + 'deal_log/all/'
  },
  worker: {
    setRemark: apiPath + 'worker/set_remark',
    sendCaptcha: apiPath + 'worker/send_captcha/',
    verifyCaptcha: apiPath + 'worker/verify_captcha/',
    bind: apiPath + 'worker/bind/',
    add: apiPath + 'worker/add/',
    del: apiPath + 'worker/del/',
    edit: apiPath + 'worker/edit/',
    get: apiPath + 'worker/get/',
    getList: apiPath + 'worker/get_list/',
    getLoopList: apiPath + 'worker/get_list_loop/',
    getHomeOrderList: apiPath + 'worker/get_order_list_home/',
    getOrderList: apiPath + 'worker/get_order_list/',
    query: apiPath + 'worker/query/'
  },
  workerServ: {
    add: apiPath + 'worker_serv/add/',
    del: apiPath + 'worker_serv/del/',
    edit: apiPath + 'worker_serv/edit/',
    getList: apiPath + 'worker_serv/get_list/'
  },
  workerArea: {
    add: apiPath + 'worker_area/add/',
    del: apiPath + 'worker_area/del/',
    edit: apiPath + 'worker_area/edit/',
    getList: apiPath + 'worker_area/get_list/'
  },
  stat: {
    assignList: apiPath + 'stat/get_assign_list',
    orderProfit: apiPath + 'stat/get_order_profit'
  },
  user: {

  },
  // order
  order: {
    upimg: apiPath + 'order/upimg/',
    add: apiPath + 'order/add/',
    edit: apiPath + 'order/edit/',
    get: apiPath + 'order/get/',
    setStatus: apiPath + 'order/set_status/',
    getList: apiPath + 'order/get_list/',
    addBefore: apiPath + 'order/add_before/',
    editBefore: apiPath + 'order/edit_before/',
    getBeforeList: apiPath + 'order/get_list_before/',
    getSendList: apiPath + 'order/get_list_send/',
    pull: apiPath + 'order/pull/', // 领取
    loop: apiPath + 'order/loop/', // 轮单
    assign: apiPath + 'order/assign/', // 指派订单
    assignNewWorker: apiPath + 'order/assign_new_worker/',
    getPrice: apiPath + 'order/get_price',
    applyCancel: apiPath + 'order/apply_cancel',
    applyCancelConfirm: apiPath + 'order/apply_cancel_confirm',
    setStar: apiPath + 'order/set_star',
    setFoot: apiPath + 'order/set_foot',
    addPrice: apiPath + 'order/add_price',
    setLock: apiPath + 'order/set_lock',
    setBack: apiPath + 'order/set_back',
    getCount: apiPath + 'order/get_count',
    remarkWorker: apiPath + 'order/set_worker_remark'
  },
  oldOrder: {
    edit: apiPath + 'old_order/edit/',
    getList: apiPath + 'old_order/get_list/',
    setStatus: apiPath + 'old_order/set_status/',
    setTop: apiPath + 'old_order/set_top/'
  },
  // content
  area: {
    add: apiPath + 'area/add/',
    del: apiPath + 'area/del/',
    edit: apiPath + 'area/edit/',
    get: apiPath + 'area/get/',
    getSub: apiPath + 'area/get_sub/',
    query: apiPath + 'area/query/',
    getPath: apiPath + 'area/get_path/'
  },
  serv: {
    add: apiPath + 'serv/add/',
    del: apiPath + 'serv/del/',
    edit: apiPath + 'serv/edit/',
    get: apiPath + 'serv/get/',
    getList: apiPath + 'serv/get_list/',
    query: apiPath + 'serv/query/',
    getSub: apiPath + 'serv/get_sub/'
  },
  servCate: {
    add: apiPath + 'serv_cate/add/',
    del: apiPath + 'serv_cate/del/',
    edit: apiPath + 'serv_cate/edit/',
    get: apiPath + 'serv_cate/get/',
    getSub: apiPath + 'serv_cate/get_sub/'
  },
  servArea: {
    add: apiPath + 'serv_area/add/',
    del: apiPath + 'serv_area/del/',
    edit: apiPath + 'serv_area/edit/',
    getList: apiPath + 'serv_area/get_list/',
    getContractorList: apiPath + 'serv_area/get_list/contractor'
  },
  contractor: {
    add: apiPath + 'contractor/add/'
  }
}

export { api, formatterList, apiEnum}

// 登陆用路由去做
// 模板消息获取access的方式用cron做
// 师傅提现等功能，企业付款回执

// 添加一个关闭下单功能（用以避免一些特殊产品，自动轮单）

// 下面订单显产品

// 置顶派单 再loop外面



// WEBPACK FOOTER //
// ./src/config.js